import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { convertSprdLocaleToIsoLocale } from '@/utils/convertSprdLocaleToIsoLocale';
import { getParams } from '@/utils/params';
import { getCurrency } from '@/redux/core/getters/getCurrency';

interface FormatterOptions {
  zeroValue?: string;
}
export const usePriceFormatter = ({ zeroValue }: FormatterOptions = {}) => {
  const currency = useSelector(getCurrency);
  const formatter = useMemo(
    () =>
      new Intl.NumberFormat(convertSprdLocaleToIsoLocale(getParams().locale), {
        style: 'currency',
        currency: currency.isoCode,
        minimumFractionDigits: currency.decimalCount,
        maximumFractionDigits: currency.decimalCount,
      }),
    [currency]
  );

  return useCallback(
    (value: number) => {
      if (value === 0 && zeroValue !== undefined) {
        return zeroValue;
      }

      return formatter.format(value);
    },
    [formatter, zeroValue]
  );
};
